module.exports = "/_next/static/images/trezor_logo_suite_square-bd75f812b0a655b9b614225a46173d8c.svg";